import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { AppToolbarService} from 'src/app/components/toolbar/services/app-toolbar.service';

@Component({
  selector: 'app-ajouter-ticket',
  templateUrl: './ajouter-ticket.component.html',
  styleUrls: ['./ajouter-ticket.component.css']
})
export class AjouterTicketComponent implements OnInit {

  lockForm: boolean = false;

  inforForm: {
    contact: string;
    client: string;
    phone: string;
    message: string;
    numsociete: string
  } = {
    contact: '',
    client: '',
    phone: '',
    message: '',
    numsociete: '0',
  };

  constructor(
    private mToolbar: AppToolbarService,
    private route: ActivatedRoute,
    private mHttp: HttpClient
  ) {
    this.mToolbar.setDisposition({start: [], end: []});
    this.mToolbar.setVisibility(false);
    // Recuperation du code de l'usine passé en param de la page
    if (this.route.snapshot.queryParams.numsociete)
      this.inforForm.numsociete = this.route.snapshot.queryParams.numsociete;
  }

  ngOnInit(): void {
    // On load le cache
    this.loadLocalStorage();
  }

  loadLocalStorage() {
    if (localStorage.getItem('client'))
      this.inforForm.client = localStorage.getItem('client') || '';
    if (localStorage.getItem('contact'))
      this.inforForm.contact = localStorage.getItem('contact') || '';
    if (localStorage.getItem('phone'))
      this.inforForm.phone = localStorage.getItem('phone') || '';
  }

  saveLocalStorage() {
    localStorage.setItem('client', this.inforForm.client);
    localStorage.setItem('contact', this.inforForm.contact);
    localStorage.setItem('phone', this.inforForm.phone);
  }

  checkValue() {
    if (
      this.inforForm.client == '' ||
      this.inforForm.contact == '' ||
      this.inforForm.message == '' ||
      this.inforForm.phone == ''
    ) {
      alert('Tous les champs doivent être remplis');
      return false;
    }
    return true;
  }

  async onSubmit() {
    if (this.checkValue()) {
      this.lockForm = true;
      try {
        await ArmaServConnection.isSessionValid(this.mHttp);  // Check de la session / renouvelle si expiré
        await ArmaServConnection.aPOST(this.mHttp, 'NewTicket', this.inforForm);
        this.saveLocalStorage();
        this.inforForm.message = '';
        alert('Message envoyé');
      } catch (e) {
        alert('Server error');
        console.error(e);
      } finally {
        this.lockForm = false;
      }
    }
  }

}
